import { Component, ElementRef, Inject, NgZone, OnChanges, PLATFORM_ID, TransferState } from '@angular/core';

import {
  DxGanttComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';

@Component({
  selector: 'abc-gantt',
  template: '',
  standalone: true,
  providers: [DxTemplateHost, WatcherHelper, IterableDifferHelper, NestedOptionHost],
})
export class _AbcGanttComponent extends DxGanttComponent {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
  }
}
